<template>
  <Drawer
      :visible="visible"
      :title="document ? document.documentName : ''"
      placement="right"
      width="1100px"
      @close="handleClose"
  >
    <div class="file-preview-container">
      <!-- 根据文档状态动态选择样式类 -->
      <div :class="document?.status === 0 ? 'preview-content' : 'preview-content-receive'">
        <div class="preview-iframe-container">
          <iframe
              v-if="document?.fileUrl"
              :src="previewUrl"
              frameborder="0"
              class="preview-iframe"
              title="文件预览"
          ></iframe>
          <div v-else class="no-file">
            无文件可预览
          </div>
        </div>
      </div>
      
      <!-- 确认签收按钮区域 - 仅当status=0时显示 -->
      <div v-if="document?.status === 0" class="receive-action">
        <Button type="primary" @click="confirmReceive">确认签收</Button>
      </div>
    </div>
  </Drawer>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { Drawer, Button, message } from 'ant-design-vue';
import { Base64 } from 'js-base64';
import { documentReceive } from '@/api/application/documents'

// 定义props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  document: {
    type: Object
  }
});

// 定义事件
const emit = defineEmits(['update:visible', 'close']);

// 处理关闭事件
const handleClose = () => {
  emit('update:visible', false);
  emit('close');
};

// 计算预览URL
const previewUrl = computed(() => {
  console.log("props.document", props.document)
  if (!props.document.fileUrl) {
    return '';
  }

  let url = '';
  // 开发环境
  if (process.env.NODE_ENV === 'development') {
    url = process.env.VUE_APP_PREVIEW_URL || '';
  } else if (process.env.NODE_ENV === 'production') {
    // 生产环境
    url = 'http://192.168.74.107:8080' + "/file-online-preview" + "/onlinePreview?url=";
  }

  return url + encodeURIComponent(Base64.encode(props.document.fileUrl));
});

// 确认签收方法
const confirmReceive = async () => {
  if (!props.document || !props.document.id) {
    message.error('文档信息不完整');
    return;
  }
  
  try {
    const res = await documentReceive({
      id: props.document.id
    });
    
    if (res.code === 200) {
      message.success('签收成功');
      // 触发关闭
      handleClose();
      // 可以发送自定义事件通知父组件刷新数据
      emit('receive-success');
    } else {
      message.error(res.message || '签收失败，请重试');
    }
  } catch (error) {
    console.error('签收失败:', error);
    message.error('网络错误，请稍后重试');
  }
};
</script>

<style scoped lang="less">
.file-preview-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.preview-content {
  width: 100%;
  // 调整为更低的高度，确保在有签收按钮时也能完整显示
  height: calc(100vh - 220px);
  display: flex;
  flex-direction: column;
}

.preview-content-receive {
  width: 100%;
  // 调整为更低的高度，确保在有签收按钮时也能完整显示
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
}

.preview-iframe-container {
  flex: 1;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.preview-iframe {
  flex: 1;
  width: 100%;
  min-height: 500px;
}

.no-file {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #999;
}

.no-file {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #999;
}

// 签收按钮区域样式
.receive-action {
  margin-top: 7px;
  text-align: center;
  padding-top: 7px;
  border-top: 1px solid #e8e8e8;
}

.receive-action :deep(.ant-btn) {
  min-width: 120px;
}
</style>